import { t, type I18nLocale } from '@ardoq/i18n';

export const getImagePreviewLabels = (i18nLocale: I18nLocale) => ({
  closeButtonText: t(i18nLocale, 'inventory:imagePreview.close', 'Close'),
  zoomButtonLabel: t(
    i18nLocale,
    'inventory:imagePreview.zoom',
    'Enlarge image'
  ),
});
